import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./auth-guard/auth.guard";
import { UserRole } from "./globals/globals";

/**
 * Lazy Loading routing.This is on demand.
 */
const routes: Routes = [
  // {
  //   path: "login",
  //   data:{
  //       role:[UserRole.SUPER_ADMIN,UserRole.MERCHANT]
  //   },
  //   loadChildren: () =>
  //     import("./controller/login/login.module").then((mod) => mod.LoginModule),
  // },
  {
    path: 'merchant-signup',
    loadComponent: () =>
      import('./user/controller/merchant-signup/merchant-signup.component').then(
        (m) => m.MerchantSignupComponent
      ),
  },
  {
    path: 'user-signup',
    loadComponent: () =>
      import('./user/controller/user-sign-up/user-sign-up.component').then(
        (m) => m.UserSignUpComponent
      ),
  },
  {
    path: 'social-signup',
    loadComponent: () =>
      import('./user/controller/social-sign-up/social-sign-up.component').then(
        (m) => m.SocialSignUpComponent
      ),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./user/controller/users-login/users-login.component').then(
        (m) => m.UsersLoginComponent
      ),
  },
  {
    path: 'contact-us',
    loadComponent: () =>
      import('./user/controller/user-contact/user-contact.component').then(
        (m) => m.UserContactComponent
      ),
  },

  { 
    path: 'delete-account-request', 
    loadChildren: () => 
      import('./controller/delete-account-request/delete-account-request.module').then(
        mod => mod.DeleteAccountRequestModule
      ) 
  },
  
  {
    path: "dashboard",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/dashboard/dashboard.module").then(
        (mod) => mod.DashboardModule
      ),
  },
  {
    path: "payment/:slug",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.MERCHANT]
    },
    loadChildren: () =>
      import("./controller/payment/payment.module").then(
        (mod) => mod.PaymentModule
      ),
  },
  {
    path: "message",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.MERCHANT]
    },
    loadChildren: () =>
      import("./controller/message-view-more/message-view-more.module").then(
        (mod) => mod.MessageViewMoreModule
      ),
  },
  {
    path: "notifications",
    canActivate: [AuthGuard],
    data:{ 
      role :[UserRole.SUPER_ADMIN,UserRole.MERCHANT]
    },
    loadChildren: () =>
      import(
        "./controller/notification-view-more/notification-view-more.module"
      ).then((mod) => mod.NotificationViewMoreModule),
  },
  {
    path: "admin-payment",
    canActivate: [AuthGuard],
    data:{ 
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/admin-payment/admin-payment.module").then(
        (mod) => mod.AdminPaymentModule
      ),
  },
  { path: 'crash-report', 
    canActivate: [AuthGuard],
    data:{

      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () => 
      import('./controller/crash-report/crash-report.module').then(m => m.CrashReportModule) 
  },
  { path: 'saved-reports', 
    canActivate: [AuthGuard],
    data:{

      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () => 
      import('./controller/saved-reports/saved-reports.module').then(m => m.SavedReportsModule) 

  },

  { path: 'tracker-report', 
    canActivate: [AuthGuard],
    data:{

      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () => 
      import('./controller/tracker-report/tracker-report.module').then(m => m.TrackerReportModule) 
  },
  { path: 'challenge-report', 
    canActivate: [AuthGuard],
    data:{

      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () => 
      import('./controller/challenge-report/challenge-report.module').then(m => m.ChallengeReportModule) 
  },
  
   {
     path: "payment-report",
   canActivate: [AuthGuard],
  data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/payment-report/payment-report.module").then(
        (mod) => mod.PaymentReportModule
      ),
  },
  {
    path: "announcement",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/announcement/announcement.module").then(
        (mod) => mod.AnnouncementModule
      ),
  },
  {
    path: "participated-in-sale",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.MERCHANT
    },
    loadChildren: () =>
      import(
        "./controller/participated-in-sale/participated-in-sale.module"
      ).then((mod) => mod.ParticipatedInSaleModule),
  },
  // {
  //   path: "signup",
  //   //canActivate:[AuthGuard],
  //   loadChildren: () =>
  //     import("./controller/sign-up/sign-up.module").then(
  //       (mod) => mod.SignUpModule
  //     ),
  // },
  {
    path: "edit-profile",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.MERCHANT,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/edit-profile/edit-profile.module").then(
        (mod) => mod.EditProfileModule
      ),
  },
  {
    path: "coupon",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.MERCHANT]
    },
    loadChildren: () =>
      import("./controller/coupon/coupon.module").then(
        (mod) => mod.CouponModule
      ),
  },
  {
    path: "coupon-report",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/coupon-report/coupon-report.module").then(
        (mod) => mod.CouponReportModule
      ),
  },
  {
    path: "special-sale",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/special-sale/special-sale.module").then(
        (mod) => mod.SpecialSaleModule
      ),
  },
  {
    path: "earn-report",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/earn-report/earn-report.module").then(
        (mod) => mod.EarnReportModule
      ),
  },
  {
    path: "store-report",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/store-report/store-report.module").then(
        (mod) => mod.StoreReportModule
      ),
  },
  {
    path: "coupon-category",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/coupon-category/coupon-category.module").then(
        (mod) => mod.CouponCategoryModule
      ),
  },
  {
    path: "manage-report-abuse",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/report-abuse/report-abuse.module").then(
        (mod) => mod.ReportAbuseModule
      ),
  },
  {
    path: "manage-referral",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/referral-manage/referral-manage.module").then(
        (mod) => mod.ReferralManageModule
      ),
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    data: { role: [UserRole.USER, UserRole.SUPER_ADMIN, UserRole.LOCALE_ADMIN] },
    loadChildren: () =>
      import('./user/user.routes').then((m) => m.USER_ROUTES),
  },
  {
    path: "admin-user",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/user/user.module").then((mod) => mod.UserModule),
  },
  {
    path: "locale-admin",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.LOCALE_ADMIN
    },
    loadChildren: () =>
      import("./controller/user/user.module").then((mod) => mod.UserModule),
  },
    {
    path: "thank-you",
        // canActivate: [AuthGuard],
    data:{
      role :[UserRole.USER]
    },
    loadChildren: () =>
      import("./controller/thank-you/thank-you.module").then((mod) => mod.ThankYoyModule),
  },
  {
    path: "locale",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/locale/locale.module").then(
        (mod) => mod.LocaleModule
      ),
  },
  {
    path: "merchant",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/merchant/merchant.module").then(
        (mod) => mod.MerchantModule
      ),
  },
  {
    path: "merchant-report",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/merchant-report/merchant-report.module").then(
        (mod) => mod.MerchantReportModule
      ),
  },
  {
    path: "user-report",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/user-report/user-report.module").then(
        (mod) => mod.UserReportModule
      ),
  },
  {
    path: "merchant-dashboard",
    data:{
      role :UserRole.MERCHANT
    },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./controller/merchant-dashboard/merchant-dashboard.module").then(
        (mod) => mod.MerchantDashboardModule
      ),
  },
  {
    path: "merchant-payment",
    canActivate: [AuthGuard],
    data:{
      role : UserRole.MERCHANT
    },
    loadChildren: () =>
      import("./controller/merchant-payment/merchant-payment.module").then(
        (mod) => mod.MerchantPaymentModule
      ),
  },
  {
    path: "store-review/:slug",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.MERCHANT]
    },
    loadChildren: () =>
      import("./controller/store-review/store-review.module").then(
        (mod) => mod.StoreReviewModule
      ),
  },
  {
    path: "admin-store",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.MERCHANT]
    },
    loadChildren: () =>
      import("./controller/store/store.module").then((mod) => mod.StoreModule),
  },
  {
    path: "report-dashboard",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/report-dashboard/report-dashboard.module").then(
        (mod) => mod.ReportDashboardModule
      ),
  },
  {
    path: "add-store",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.MERCHANT]
    },
    loadChildren: () =>
      import("./controller/add-store/add-store.module").then(
        (mod) => mod.AddStoreModule
      ),
  },
  {
    path: "manage-post",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/manage-post/manage-post.module").then(
        (mod) => mod.ManagePostModule
      ),
  },
  {
    path: "manage-post/:slug",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/manage-post/manage-post.module").then(
        (mod) => mod.ManagePostModule
      ),
  },
  {
    path: "admin-community",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/community/community.module").then(
        (mod) => mod.CommunityModule
      ),
  },
  {
    path: "community-report",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/community-report/community-report.module").then(
        (mod) => mod.CommunityReportModule
      ),
  },
  {
    path: "admin-community/:slug",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/community/community.module").then(
        (mod) => mod.CommunityModule
      ),
  },
  {
    path: "store-categories",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/store-categories/store-categories.module").then(
        (mod) => mod.StoreCategoriesModule
      ),
  },
  {
    path: "team",
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./controller/team/team.module").then((mod) => mod.TeamModule),
  },
  {
    path: "custom-field/:slug",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/custom-field/custom-field.module").then(
        (mod) => mod.CustomFieldModule
      ),
  },
  {
    path: "custom-field",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/custom-field/custom-field.module").then(
        (mod) => mod.CustomFieldModule
      ),
  },
  {
    path: "about-us",
    //canActivate:[AuthGuard],
    loadChildren: () =>
      import("./controller/about-us/about-us.module").then(
        (mod) => mod.AboutUsModule
      ),
  },
  {
    path: "privacy-policy",
    //canActivate:[AuthGuard],
    loadChildren: () =>
      import("./controller/privacy-policy/privacy-policy.module").then(
        (mod) => mod.PrivacyPolicyModule
      ),
  },
  {
    path: "terms-of-use",
    //canActivate:[AuthGuard],
    loadChildren: () =>
      import("./controller/terms-of-use/terms-of-use.module").then(
        (mod) => mod.TermsOfUseModule
      ),
  },
  {
    path: "unit-type",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/unit-type/unit-type.module").then(
        (mod) => mod.UnitTypeModule
      ),
  },
  {
    path: "manage-unit",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/unit/unit.module").then((mod) => mod.UnitModule),
  },
  {
    path: "manage-activities",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/manage-activities/manage-activities.module").then(
        (mod) => mod.ManageActivitiesModule
      ),
  },
  {
    path: "manage-tracker-type",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import(
        "./controller/manage-tracker-type/manage-tracker-type.module"
      ).then((mod) => mod.ManageTrackerTypeModule),
  },
  {
    path: "manage-tracker",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/manage-tracker/manage-tracker.module").then(
        (mod) => mod.ManageTrackerModule
      ),
  },
  {
    path: "manage-notification",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/manage-notification/manage-notification.module").then(
        (mod) => mod.ManageNotificationModule
      ),
  },
  {
    path: "manage-food",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import("./controller/manage-food/manage-food.module").then(
        (mod) => mod.ManageFoodModule
      ),
  },
  {
    path: "set-default-tracker",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import(
        "./controller/set-default-tracker/set-default-tracker.module"
      ).then((mod) => mod.SetDefaultTrackerModule),
  },
  {
    path: "manage-challenge-categories",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import(
        "./controller/manage-challenge-categories/manage-challenge-categories.module"
      ).then((mod) => mod.ManageChallengeCategoriesModule),
  },
  {
    path: "manage-map",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/manage-map/manage-map.module").then(
        (mod) => mod.ManageMapModule
      ),
  },
  {
    path: "manage-program",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/program/program.module").then(
        (mod) => mod.ProgramModule
      ),
  },
  {
    path: "manage-program/:slug",
    canActivate: [AuthGuard],
    data:{
      role :[UserRole.SUPER_ADMIN,UserRole.LOCALE_ADMIN]
    },
    loadChildren: () =>
      import("./controller/program/program.module").then(
        (mod) => mod.ProgramModule
      ),
  },
  {
    path: "email-temp-management",
    canActivate: [AuthGuard],
    data:{
      role :UserRole.SUPER_ADMIN
    },
    loadChildren: () =>
      import(
        "./controller/emailtemp-management/emailtemp-management.module"
      ).then((mod) => mod.EmailtempManagementModule),
  },
  {
    path: "auth", 
    loadChildren: () =>
    import("./controller/login/login.module").then((mod) => mod.LoginModule),
  },
  {
    path: "notification",
    loadChildren: () =>
      import("./controller/notification/notification.module").then((mod) => mod.NotificationModule),
  },
  {
    path: "",
    loadChildren: () =>
      import("./controller/home/home.module").then((mod) => mod.HomeModule),
  },
  {
    path: "**",
    loadChildren: () =>
      import("./controller/page-not-found/page-not-found.module").then(
        (mod) => mod.PageNotFoundModule
      ),
  },

  {
    path: "",
    redirectTo: "",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
})],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
